import {
  Stack,
  styled,
  Typography,
  Button as MuiButton,
  Box,
  css,
} from '@mui/material';
import COLORS from '@app/colors';

const actionButtonBase = css`
  width: 100%;
  justify-content: flex-start;
  padding: 18px 24px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 12px;
  text-transform: none;
  box-shadow: none;
  transition: background-color 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;

  .MuiButton-startIcon {
    margin-right: 12px;
    margin-left: 0;
  }
`;

export const DashboardContainer = styled(Stack)`
  align-items: center;
  padding: 90px 24px 32px;
  flex-grow: 1;

  ${({ theme }) => css`
    ${theme.breakpoints.down('sm')} {
      padding-top: 32px;
    }
  `}

  > img {
    width: 160px;
    height: 160px;
    object-fit: contain;
  }
`;

export const Title = styled(Typography)`
  font-family: 'Source Serif Pro', serif;
  font-weight: 700;
  font-size: 48px;
  line-height: 1.15;
  color: ${COLORS.green};
  text-align: center;
  margin: 40px 0 32px;

  ${({ theme }) => css`
    ${theme.breakpoints.down('sm')} {
      font-size: 36px;
      margin: 24px 0;
    }
  `}
`;

export const ActionsGroup = styled(Stack)`
  width: 100%;
  max-width: 380px;
  gap: 12px;
`;

export const PrimaryAction = styled(MuiButton)`
  ${actionButtonBase}
  background: ${COLORS.green};
  color: white;
  box-shadow: 0 4px 14px rgba(4, 126, 80, 0.22);

  &:hover {
    background: #036b44;
    box-shadow: 0 6px 20px rgba(4, 126, 80, 0.32);
  }
`;

export const AssistantAction = styled(MuiButton)`
  ${actionButtonBase}
  background: rgba(4, 126, 80, 0.08);
  color: ${COLORS.green};
  border: 1.5px solid ${COLORS.green};

  &:hover {
    background: rgba(4, 126, 80, 0.14);
    border-color: ${COLORS.green};
  }
`;

export const SecondaryAction = styled(MuiButton)`
  ${actionButtonBase}
  background: white;
  color: ${COLORS.black};
  border: 1px solid rgba(37, 37, 37, 0.14);

  &:hover {
    background: #fafafa;
    border-color: rgba(37, 37, 37, 0.28);
  }
`;

export const Footer = styled(Box)`
  margin-top: auto;
  padding-top: 48px;
`;
